import { lazy, Suspense } from 'react';
import { useAppStore, type IAppStore } from '@/store';
import type { Screen } from '@/types';
import { useMobileLayoutStyles } from './styles';

const PresetGallery = lazy(() => import('@/components/PresetGallery'));
const Create = lazy(() => import('@/components/Create'));
const Loading = lazy(() => import('@/components/Loading'));
const Result = lazy(() => import('@/components/Result'));
const Generations = lazy(() => import('@/components/Generations'));

// External selector for stable reference
const selector = (store: IAppStore) => store.screen;

const screenComponents: Record<
  Screen,
  React.LazyExoticComponent<React.ComponentType>
> = {
  library: PresetGallery,
  create: Create,
  loading: Loading,
  result: Result,
  files: Generations,
};

export const MobileLayout = () => {
  const screen = useAppStore(selector);
  const classes = useMobileLayoutStyles();
  const Component = screenComponents[screen] || PresetGallery;

  return (
    <div className={classes.mobileContent}>
      <Suspense fallback={null}>
        <Component />
      </Suspense>
    </div>
  );
};
